export default "__VITE_ASSET__CPO8pScq__"